// Returns a selector for requested prop kinds as well as the propTypes for
// those props merged into one object
export default function selectSystemProps(systemPropHelpers) {
  const selectProps = props => systemPropHelpers.reduce((acc, propHelper) => {
    if (typeof (propHelper === null || propHelper === void 0 ? void 0 : propHelper.select) !== 'function') {
      throw new Error(`An invalid system prop helper has been passed to 'selectSystemProps': prop selector ('.select') is missing in ${propHelper}`);
    }

    return { ...acc,
      ...propHelper.select(props)
    };
  }, {});

  const selectedPropTypes = systemPropHelpers.reduce((acc, propHelper) => {
    if (!(propHelper !== null && propHelper !== void 0 && propHelper.types)) {
      throw new Error(`An invalid system prop helper has been passed to 'selectSystemProps': types selector ('.types') is missing in ${propHelper}`);
    }

    return { ...acc,
      ...propHelper.types
    };
  }, {});
  return [selectProps, selectedPropTypes];
}